// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT FUNCTIONS
import { swipersInit } from './functions/sliders';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior } from './functions/actionsForm';
import { redirectPage } from './functions/redirectPage';

document.addEventListener('DOMContentLoaded', function() {

  // INIT LAZY LOADING
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
  });

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();
  
  $('.footer-fixed').toggle($('.whatsapp-cta, .btn-calltracking').length > 0);
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('modal-close') ? popClose() : false
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
});
